import React from 'react'
import { IdListPageStyle } from './IdListInput.styled';

const IdListInput = ({ ids, onRemove }) => {
  return (
    <IdListPageStyle>
      {ids.map((id, index) => (
        <div key={index} className='input-div'>
          <input className="form-control input-field" value={id} readOnly disabled />
          <i className="bi bi-dash-circle remove-icon" onClick={() => onRemove(index)} title='Remove'/>
        </div>
      ))}
    </IdListPageStyle>
  );
};

export default IdListInput